import React, { useEffect } from 'react';
import styled from 'styled-components';

import { connect } from 'react-redux';
import { getHraForm } from '../../services';
import VisitHeader from '../common/header';
import { Player } from '@lottiefiles/react-lottie-player';
import LoadingComponent from '../../components/common/LoadingComponent';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  height: 100%;
  background: #ffffff;
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ExitScreen = ({ config, history }) => {
  //set the scroll value of element with id 'hra-progress-bar' to 100 on component mount

  const [currentQuestion, setCurrentQuestion] = React.useState({
    allSections: [],
  });
  const [loading, setLoading] = React.useState(true);
  const [totalSections, setTotalSections] = React.useState(0);
  const [currentSection, setCurrentSection] = React.useState(0);
  const [remainingSections, setRemainingSections] = React.useState(0);

  useEffect(() => {
    getHraForm()
      .then((res) => {
        if (res.message === 'success') {
          setLoading(false);
          setCurrentQuestion(res.question);
          const remainingSections =
            res.question.currentProgress.remainingSections;
          const totalSections = res.question.currentProgress.totalSections;
          const currentSection = totalSections - remainingSections;
          setTotalSections(totalSections);
          setCurrentSection(currentSection);
          setRemainingSections(remainingSections);
          if (remainingSections || currentSection === totalSections) {
            document
              .getElementById('hra-progress-bar')
              .scrollTo(125 * currentSection, 0);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const closeView = () => {
    if (typeof window.Android !== 'undefined') {
      return window.Android.closeView();
    } else if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'closeView',
        })
      );
    } else {
      history.go(-2);
    }
  };

  // console.log(currentQuestion);
  if (loading) return <LoadingComponent />;
  return (
    <>
      <VisitHeader showMenu={false} />
      <OuterContainer className="font-mont">
        <div className="flex flex-col p-32px overflow-y-scroll flex-1 text-center justify-start item-center">
          {config.hraLogo && config.showUpdatedHra ? (
            <div className="flex flex-row items-center justify-between m-x mr-12px">
              <img
                src={
                  'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png'
                }
                alt={'Visit Health'}
                style={{ width: '30%', maxWidth: '150px' }}
              />
              <img
                src={config.hraLogo}
                style={{ width: '45%', maxWidth: '250px' }}
                alt={'HRA Logo'}
              />
            </div>
          ) : (
            <div></div>
          )}
          <ColumnContainer>
            <Player
              src="https://assets2.lottiefiles.com/packages/lf20_yEQpwWv2BZ.json"
              // height={193}
              // width={193}
              style={{ height: '193px', width: '193px' }}
              autoplay
              loop
            />
            <p className="text-title-xl font-bold text-custom714fff">
              Current Progress Saved
            </p>
            <p
              className="text-body-l mt-20px pb-10px font-medium text-brochure leading-6"
              style={{
                maxWidth: '500px',
                borderBottom: '1px solid #E5E5E5',
              }}
              id="hra-disclaimer"
            >
              Start where you left! Your current progress is saved, come back
              any time to complete the Health Risk Assessment.
            </p>
          </ColumnContainer>
          {currentQuestion.hraFitcoinStatus &&
            currentQuestion.hraFitcoinStatus.fitcoinAvailable && (
              <ColumnContainer>
                <p
                  className="text-body-l mt-20px font-medium text-brochure leading-6"
                  style={{
                    maxWidth: '500px',
                  }}
                  id="hra-disclaimer"
                >
                  You can still win
                </p>
                <p className="text-title-l font-bold text-custom3a2ca0">
                  {currentQuestion.hraFitcoinStatus.remaining} more
                  <span className="text-customFFEA5A"> FIT Coins</span>
                </p>
              </ColumnContainer>
            )}
          {currentQuestion.hraFitcoinStatus &&
          currentQuestion.hraFitcoinStatus.earnedFitcoin > 0 &&
          currentQuestion.hraFitcoinStatus.remaining === 0 ? (
            <ColumnContainer>
              <p
                className="text-body-l mt-20px font-medium text-brochure leading-6"
                style={{
                  maxWidth: '500px',
                }}
                id="hra-disclaimer"
              >
                You have earned
              </p>
              <p className="text-title-l font-bold text-custom3a2ca0">
                {currentQuestion.hraFitcoinStatus.earnedFitcoin}{' '}
                <span className="text-customFFEA5A"> FIT Coins</span>
              </p>
            </ColumnContainer>
          ) : (
            ''
          )}
          <ColumnContainer
            style={{
              backgroundColor: '#fffaeb',
              height: '150px',
              margin: '0 -32px',
              marginTop: 20,
            }}
          >
            <p
              className="text-body-l mt-10px mb-5 font-semibold text-black leading-6"
              style={{
                maxWidth: '500px',
              }}
              id="hra-disclaimer"
            >
              You’re on Section {currentSection}/{totalSections}
            </p>
            <div
              id="hra-progress-bar"
              style={{
                maxWidth: '375px',
                overflow: 'scroll',
                height: '80px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                // alignItems: 'center',
                '-webkit-mask-image':
                  'linear-gradient(90deg, rgba(0, 0, 0, .01) 0%, rgba(0, 0, 0, 0.6) 10%, rgb(0, 0, 0) 30%, rgba(0, 0, 0, 0.6) 90%, rgba(0, 0, 0, 0.1) 100%)',
              }}
            >
              <div
                style={{
                  marginTop: '20px',
                  minWidth: '125px',
                  height: '18px',
                }}
              />
              <div
                style={{
                  marginTop: '20px',
                  minWidth: '125px',
                  height: '18px',
                }}
              />
              {currentQuestion &&
                currentQuestion.allSections.map((section, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        marginTop: '20px',
                        minWidth: '125px',
                        fontSize:
                          section === currentQuestion.title ? '12px' : '10px',
                        fontWeight:
                          section === currentQuestion.title ? '700' : 600,
                        color:
                          section === currentQuestion.title
                            ? '#000'
                            : '#A5A6BB',
                        borderRight: '1px solid #BDBDBD',
                        height: '18px',
                      }}
                    >
                      {section}
                    </div>
                  );
                })}
              <div
                style={{
                  marginTop: '20px',
                  minWidth: '125px',
                  height: '18px',
                }}
              />
              <div
                style={{
                  marginTop: '20px',
                  minWidth: '125px',
                  height: '18px',
                }}
              />
            </div>
            <p className="text-body-s -mt-15px font-medium text-black leading-6">
              Swipe to move
            </p>
          </ColumnContainer>
          <ColumnContainer>
            <div
              className="p-14px py-8px mt-20 rounded-full self-center cursor-pointer w-half border-2 border-custom714fff"
              onClick={() => closeView()}
            >
              <p className="font-bold text-title-l text-custom714fff ">OKAY</p>
            </div>
          </ColumnContainer>
        </div>
      </OuterContainer>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    config: state.app.config,
  };
};

export default connect(mapStateToProps)(ExitScreen);
